'use client';

import { cn } from '@/lib/utils';

const variants = {
  primary: 'bg-blue-500 text-white hover:bg-blue-600 shadow-lg shadow-blue-500/30',
  secondary: 'bg-white border border-slate-200 text-slate-600 hover:bg-slate-50',
  danger: 'bg-red-500 text-white hover:bg-red-600 shadow-lg shadow-red-500/30',
  success: 'bg-green-500 text-white hover:bg-green-600 shadow-lg shadow-green-500/30',
  ghost: 'text-slate-600 hover:bg-slate-100',
  workerPrimary: 'bg-green-500 text-white hover:bg-green-600 shadow-lg shadow-green-500/30',
  employerPrimary: 'bg-blue-500 text-white hover:bg-blue-600 shadow-lg shadow-blue-500/30',
};

const sizes = {
  sm: 'py-2 px-4 text-sm',
  md: 'py-3 px-5 text-base',
  lg: 'py-4 px-6 text-base',
};

export default function Button({
  children,
  variant = 'primary',
  size = 'md',
  fullWidth = false,
  disabled = false,
  loading = false,
  className,
  ...props
}) {
  return (
    <button
      className={cn(
        'font-semibold rounded-xl transition-all duration-200',
        'disabled:opacity-50 disabled:cursor-not-allowed',
        'active:scale-[0.98]',
        variants[variant],
        sizes[size],
        fullWidth && 'w-full',
        className
      )}
      disabled={disabled || loading}
      {...props}
    >
      {loading ? (
        <span className="flex items-center justify-center gap-2">
          <svg
            className="animate-spin h-5 w-5"
            viewBox="0 0 24 24"
          >
            <circle
              className="opacity-25"
              cx="12"
              cy="12"
              r="10"
              stroke="currentColor"
              strokeWidth="4"
              fill="none"
            />
            <path
              className="opacity-75"
              fill="currentColor"
              d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"
            />
          </svg>
          <span className="opacity-70">{children}</span>
        </span>
      ) : (
        children
      )}
    </button>
  );
}
